module.exports = __webpack_public_path__ + "static/media/interested.13b5c8bb.svg";